import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { login, logout } from '../../actions/loginAction';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import Const from '../../const';
import { formatYMD, formatYMDHMS } from '../../lib/util/dateUtil';
import image from '../../res/image';

class Chatting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        current: 1,
        total: 0,
      },
      chatMessages: [],
      chatMessageCurrent: 0,
      chatMessageEnd: false,

      lastChatTime: {},

      currentRoom: null,
      keyInputModalOpen: false,

      checkAdmin: false,
    };
  }

  componentDidMount() {
    if (this.props.selectedRider) {
      httpGet(
        httpUrl.chatListReceiver,
        [1, 1, this.props.selectedRider.idx],
        {}
      ).then((res) => {
        if (res.result === 'SUCCESS') {
          if (res.data.chatRooms.length > 0) {
            this.setState(
              {
                currentRoom: res.data.chatRooms[0],
              },
              () => this.getChatDetail()
            );
          } else {
            this.setState({
              currentRoom: {
                idx: 'fakeIdx',
                lastChatDate: '',
                lastMessage: '',
                member1: this.props.selectedRider.idx,
                member1Name: this.props.selectedRider.riderName,
                member2: this.props.selectedRider.idx,
                member2Name: this.props.selectedRider.idx,
                title: 'chat room',
                isFake: true,
              },
            });
          }
        }
      });
    }

    global.chatAprear = true;
    global.chatListener = (data) => {
      this.updateLastChatMessage(data.idx, data.lastMessage);
      this.updateTime(data.idx);

      if (this.state.currentRoom && this.state.currentRoom.idx == data.idx) {
        this.state.chatMessages.unshift({
          chatDate: formatYMDHMS(new Date()),
          chatMessage: data.lastMessage,
          chatRoomCreateDate: '',
          chatRoomIdx: null,
          idx: 0,
          isRead: null,
          member1: data.member1,
          member2: data.member2,
          readDate: null,
          receiveUserIdx: this.props.loginReducer.loginInfo.idx,
          sendUserIdx: (() => {
            if (!isNaN(data.sendUserIdx) && 0 < data.sendUserIdx) {
              return data.sendUserIdx;
            } else {
              return this.props.loginReducer.loginInfo.idx == data.member1
                ? data.member2
                : data.member1;
            }
          })(),
          title: 'chat room',
        });
        this.setState({ chatMessages: this.state.chatMessages });
      }
    };
    this.getChatList();
    let value = reactLocalStorage.getObject(Const.appName + ':chat');

    if (value !== null) {
      try {
        value = JSON.parse(value);
        this.setState({ lastChatTime: value });
      } catch {}
    }
  }

  componentWillUnmount() {
    global.chatAprear = false;

    global.chatListener = null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen) {
    }
  }

  formatChatDate(time) {
    return time.substr(0, 10) === formatYMD(new Date())
      ? time.substr(12, time.length)
      : time.substr(0, 10);
  }

  formatChatName(item) {
    const name =
      item.member1 === this.props.loginReducer.loginInfo.idx
        ? item.member2Name
        : item.member1Name;
    return name ? name : '(알수없음)';
  }

  updateTime = (idx) => {
    //방열릴때
    let value = reactLocalStorage.getObject(Const.appName + ':chat');
    const currentTime = formatYMDHMS(new Date());
    if (value !== null) {
      try {
        if (value) value = JSON.parse(value);
        else value = [];

        let currentRoom = value.find((x) => x.idx === idx);
        if (currentRoom) {
          currentRoom.lastChatDate = currentTime;
        } else {
          value.push({
            idx: idx,
            lastChatDate: currentTime,
          });
        }
        reactLocalStorage.setObject(
          Const.appName + ':chat',
          JSON.stringify(value)
        );

        this.setState({ lastChatTime: value });
      } catch {}
    }
  };

  getChatList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.chatList, [10, pageNum], {})
      .then((result) => {
        const pagination = { ...this.state.pagination };
        pagination.current = result.data.currentPage;
        pagination.total = result.data.totalCount;
        this.setState({
          tableData: result.data.chatRooms,
          pagination,
        });
      })
      .catch();
  };
  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState(
      {
        pagination: pager,
      },
      () => this.getChatList()
    );
  };

  // 채팅상세
  chatDetailList = (item) => {
    if (item.member1Data.userType === 4 || item.member2Data.userType === 4) {
      this.setState({ checkAdmin: true });
    } else this.setState({ checkAdmin: false });

    this.setState(
      {
        currentRoom: item,
        chatMessages: [],
        chatMessageCurrent: 0,
        chatMessageEnd: false,
      },
      () => this.getChatDetail()
    );
    this.updateTime(item.idx);
  };
  getChatDetail = () => {
    if (this.state.chatMessageEnd) return;
    httpGet(
      httpUrl.chatMessageList,
      [10, this.state.chatMessageCurrent + 1, this.state.currentRoom.idx],
      {}
    )
      .then((result) => {
        result = result.data;
        if (result.chatMessages.length === 0) {
          this.setState({
            chatMessageEnd: true,
            chatMessages: this.state.chatMessages,
          });
          return;
        }
        if (this.state.chatMessageCurrent === result.currentPage)
          result.chatMessages = [];

        this.setState({
          chatMessages: this.state.chatMessages.concat(result.chatMessages),
          chatMessageCurrent: result.currentPage,
        });
      })
      .catch();
  };

  updateLastChatMessage = (idx, message) => {
    const target = this.state.tableData.find((x) => x.idx === idx);
    if (target) {
      target.lastMessage = message;
      this.setState({ tableDate: this.state.tableData });
    }
  };
  onPressSend = (msg) => {
    if (!this.state.currentRoom) return;
    const { currentRoom } = this.state;
    const receiveUserIdx =
      currentRoom.member1 === this.props.loginReducer.loginInfo.idx
        ? currentRoom.member2
        : currentRoom.member1;
    httpPost(httpUrl.chatSend, [], {
      chatMessage: msg,
      receiveUserIdx,
      sessionId:
        undefined !== global.ws && null !== global.ws
          ? global.ws.getSessionId()
          : null,
    }).then((result) => {
      result = result.data;
      if (result === 'SUCCESS') {
        this.state.chatMessages.unshift({
          chatDate: formatYMDHMS(new Date()),
          chatMessage: msg,
          chatRoomCreateDate: '',
          chatRoomIdx: null,
          idx: 0,
          isRead: null,
          member1: currentRoom.member1,
          member2: currentRoom.member2,
          readDate: null,
          receiveUserIdx: receiveUserIdx,
          sendUserIdx: this.props.loginReducer.loginInfo.idx,
          title: 'chat room',
        });
        this.setState({ chatMessages: this.state.chatMessages });
        this.updateTime(currentRoom.idx);
        this.updateLastChatMessage(currentRoom.idx, msg);
        if (this.state.currentRoom.isFake) {
          httpGet(
            httpUrl.chatListReceiver,
            [1, 1, this.props.selectedRider.idx],
            {}
          ).then((res) => {
            if (res.result === 'SUCCESS') {
              if (res.data.chatRooms.length > 0) {

                this.setState(
                  {
                    currentRoom: res.data.chatRooms[0],
                  },
                  () => {
                    this.setState({ chatMessages: [] });
                    this.getChatDetail();
                  }
                );
              }
            }
          });
        }
      }
    });
  };

  render() {
    const { isOpen, close } = this.props;
    const { currentRoom } = this.state;
    return (
      <>
        <div
          className={'Modal-overlay'}
          onClick={() => {
            this.setState({ currentRoom: null, msgInputModalOpen: false });
            close();
          }}
        />
        <div className={'Modal-chat-detail'}>
          {currentRoom && (
            <div className="chat-message-container">
              <div className="chat-title">
                <div>
                  <img
                    style={{ display: 'inline' }}
                    src={image.LeftBtn3Icon}
                    onClick={() => {
                      this.props.close();
                    }}
                  />
                </div>

                <div>{this.formatChatName(currentRoom)}</div>
              </div>
              <div className="chat-message" id="chat-message">
                <InfiniteScroll
                  dataLength={this.state.chatMessages.length}
                  next={this.getChatDetail}
                  style={{
                    display: 'flex',
                    flexDirection: 'column-reverse',
                  }} //To put endMessage and loader to the top.
                  inverse={true} //
                  hasMore={!this.chatMessageEnd}
                  scrollableTarget="chat-message">
                  {this.state.chatMessages.map((row, index) => {
                    if (
                      row.sendUserIdx === this.props.loginReducer.loginInfo.idx
                    )
                      return (
                        <div className="chat-message-item my">
                          <div className="chat-message-content my">
                            <div className="chat-message-content-text my">
                              {row.chatMessage}
                            </div>
                            <div className="chat-message-content-date my">
                              {row.chatDate}
                            </div>
                          </div>
                        </div>
                      );
                    else
                      return (
                        <div className="chat-message-item">
                          <div className="chat-message-icon">
                            <img
                              style={{ display: 'inline' }}
                              src={image.ChatDefaultIcon}
                              alt=""
                            />
                          </div>
                          <div className="chat-message-content">
                            <div className="chat-message-content-text">
                              {row.chatMessage}
                            </div>
                            <div className="chat-message-content-date">
                              {row.chatDate}
                            </div>
                          </div>
                        </div>
                      );
                  })}
                </InfiniteScroll>
              </div>
              <div className="chat-input">
                <input
                  className="chat-send-input"
                  placeholder="메세지를 입력해주세요."
                  onChange={(e) => this.setState({ sendMsg: e.target.value })}
                  value={this.state.sendMsg}
                  onFocus={() => {
                    this.setState({
                      msgInputModalOpen: this.state.checkAdmin ? false : true,
                    });
                  }}
                />
                <div
                  className="chat-send-btn"
                  onClick={() => {
                    this.onPressSend(this.state.sendMsg);
                    this.setState({ sendMsg: '' });
                  }}>
                  전송
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ login, logout }, dispatch);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Chatting)
);
